<template>
    <div>
        <!-- FASE 4 / BLOCO AE — CI 1, 21-25, 28, 35, 36, 38, 54-57 -->

        <el-row :gutter="10" class="u-mt-10 u-mb-10">
            <el-col :xs="24" :sm="10" :md="10">
                <el-input v-model="filtro.termo" clearable
                          placeholder="Buscar por assunto ou identificador..."
                          @keyup.native.enter="carregar">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </el-col>
            <el-col :xs="12" :sm="4" :md="4">
                <el-select v-model="filtro.tipo_id" placeholder="Tipo" clearable
                           style="width:100%" @change="carregar">
                    <el-option v-for="t in tipos" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="6" :sm="3" :md="3">
                <el-date-picker v-model="filtro.de" type="date" placeholder="De"
                                value-format="yyyy-MM-dd" style="width:100%" @change="carregar"></el-date-picker>
            </el-col>
            <el-col :xs="6" :sm="3" :md="3">
                <el-date-picker v-model="filtro.ate" type="date" placeholder="Até"
                                value-format="yyyy-MM-dd" style="width:100%" @change="carregar"></el-date-picker>
            </el-col>
            <el-col :xs="24" :sm="4" :md="4" class="u-text-right">
                <router-link to="/admin/tarefa/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVA TAREFA</el-button>
                </router-link>
            </el-col>
        </el-row>

        <el-tabs v-model="caixa" @tab-click="trocarCaixa" class="u-mb-10">
            <el-tab-pane label="Caixa de entrada" name="entrada"></el-tab-pane>
            <el-tab-pane label="Enviadas"         name="enviadas"></el-tab-pane>
            <el-tab-pane label="Rascunhos"        name="rascunhos"></el-tab-pane>
            <el-tab-pane label="Arquivadas"       name="arquivadas"></el-tab-pane>
        </el-tabs>

        <el-row class="u-mb-10" v-if="selecionadas.length">
            <el-col :xs="24">
                <el-button size="mini" icon="el-icon-check" @click="marcarLote(true)">
                    MARCAR COMO LIDAS ({{ selecionadas.length }})
                </el-button>
                <el-button class="u-ml-10" size="mini" icon="el-icon-close" @click="marcarLote(false)">
                    MARCAR COMO NÃO LIDAS
                </el-button>
            </el-col>
        </el-row>

        <div class="container-table" v-loading="!statusList">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th style="width:34px" class="u-text-center">
                            <el-checkbox :value="todasSelecionadas" @change="alternarTodas"></el-checkbox>
                        </th>
                        <th style="width:130px" class="hidden-mobile">Identificador</th>
                        <th>Assunto</th>
                        <th class="hidden-mobile u-text-center" style="width:110px">Situação</th>
                        <th class="hidden-mobile u-text-center" style="width:120px">Prazo</th>
                        <th class="u-text-center" style="width:150px">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="t in items" :key="t.id" :class="{ 'nao-lida': !t.lida }">
                        <td class="u-text-center">
                            <el-checkbox :value="selecionadas.indexOf(t.id) >= 0"
                                         @change="alternar(t.id)"></el-checkbox>
                        </td>
                        <td class="hidden-mobile">
                            <span class="ident">{{ t.identificador || '—' }}</span>
                        </td>
                        <td>
                            <router-link :to="'/admin/tarefa/detalhe/'+t.id" class="assunto">
                                {{ t.assunto }}
                            </router-link>
                            <!-- CI 22, 24 — destaques -->
                            <el-tag v-if="t.ultimo_tramite_tipo === 'resposta'" size="mini" type="success" class="u-ml-5">respondida</el-tag>
                            <el-tag v-if="t.ultimo_tramite_tipo === 'encaminhamento'" size="mini" type="warning" class="u-ml-5">encaminhada</el-tag>
                            <el-tag v-if="t.sou_remetente" size="mini" type="info" class="u-ml-5">enviada por você</el-tag>
                            <el-tag v-if="t.confirmou_leitura" size="mini" class="u-ml-5">leitura confirmada</el-tag>
                            <el-tag v-if="t.privada" size="mini" type="danger" class="u-ml-5">privada</el-tag>
                            <el-tag v-if="t.qtd_anexos" size="mini" class="u-ml-5">
                                <i class="el-icon-paperclip"></i> {{ t.qtd_anexos }}
                            </el-tag>
                            <!-- CI 23 — trecho sem abrir -->
                            <div class="trecho" v-if="t.trecho">{{ t.trecho }}</div>
                        </td>
                        <td class="hidden-mobile u-text-center">
                            <el-tag size="mini" :type="corSituacao(t.situacao)">{{ t.situacao }}</el-tag>
                        </td>
                        <!-- CI 57 — tempo restante sem abrir -->
                        <td class="hidden-mobile u-text-center">
                            <span v-if="t.horas_restantes === null">—</span>
                            <span v-else :class="t.prazo_vencido ? 'prazo-vencido' : 'prazo-ok'">
                                {{ textoPrazo(t) }}
                            </span>
                        </td>
                        <td class="u-text-center acao">
                            <router-link :to="'/admin/tarefa/detalhe/'+t.id" class="link-icon u-mr-10">
                                <el-button type="info" icon="el-icon-view" size="mini" plain title="Abrir"></el-button>
                            </router-link>
                            <el-button v-if="caixa !== 'arquivadas'" type="warning" icon="el-icon-folder"
                                       size="mini" plain title="Arquivar" @click="arquivar(t, true)"></el-button>
                            <el-button class="u-ml-10" v-else type="success" icon="el-icon-refresh-left"
                                       size="mini" plain title="Desarquivar" @click="arquivar(t, false)"></el-button>
                            <!-- CI 37 — continuar a redação de um rascunho -->
                            <router-link v-if="caixa === 'rascunhos'" :to="'/admin/tarefa/edit/'+t.id"
                                         class="link-icon u-mr-10">
                                <el-button type="primary" icon="el-icon-edit" size="mini" plain
                                           title="Continuar redação"></el-button>
                            </router-link>
                            <el-button v-if="caixa === 'rascunhos'" type="danger" icon="el-icon-delete"
                                       size="mini" plain title="Excluir rascunho" @click="excluir(t)"></el-button>
                        </td>
                    </tr>
                    <tr v-if="!items.length && statusList">
                        <td colspan="6" class="u-text-center u-mt-25">Nenhuma tarefa nesta caixa.</td>
                    </tr>
                </tbody>
            </table>

            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
                                       @current-change="getPagePagination" :page-size="30" background
                                       layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

export default {
    props: ['caixaInicial'],
    data: () => ({
        statusList: false,
        caixa: 'entrada',
        items: [],
        tipos: [],
        selecionadas: [],
        filtro: { termo: '', tipo_id: '', de: '', ate: '' },
        paginate: { page: 1, qtdItens: 0, from: '', to: '' }
    }),
    computed: {
        todasSelecionadas () {
            return this.items.length > 0 && this.selecionadas.length === this.items.length
        }
    },
    mounted () {
        if (this.caixaInicial) this.caixa = this.caixaInicial
        this.carregarTipos()
        this.carregar()

        // CI 6 — a troca de grupo no cabeçalho recarrega a caixa sem sair da tela.
        window.eventBus.$on('grupo-trabalho-alterado', this.aoTrocarGrupo)
    },
    beforeDestroy () {
        window.eventBus.$off('grupo-trabalho-alterado', this.aoTrocarGrupo)
    },
    watch: {
        '$route' () {
            if (this.caixaInicial) { this.caixa = this.caixaInicial; this.paginate.page = 1; this.carregar() }
        }
    },
    methods: {
        base () { return this.$store.state.config.baseUrlApi },
        auth () { return this.$store.getters.getHeaderAuth },

        erro (e) {
            window.eventBus.$emit('loading', false)
            const d = e && e.response ? e.response.data : null
            let msg = 'Não foi possível concluir a operação.'
            if (d && typeof d.erro === 'string') msg = d.erro
            else if (d && d.erro && d.erro.text) msg = d.erro.text
            window.eventBus.$emit('alert', { msg: msg, type: 'error' })
            this.$store.commit('throwException', e)
        },

        carregarTipos () {
            this.$axios.post(`${this.base()}/api/tarefa-tipo/getAll`, {}, this.auth())
                .then(r => { this.tipos = r.data })
                .catch(e => { this.erro(e) })
        },

        carregar () {
            this.statusList = false
            this.items = []
            this.selecionadas = []

            const payload = Object.assign({ caixa: this.caixa }, this.filtro)

            this.$axios.post(`${this.base()}/api/tarefa/listar?page=${this.paginate.page}`,
                payload, this.auth()).then(r => {
                this.items = r.data.data
                this.paginate.qtdItens = r.data.total
                this.paginate.from = r.data.from
                this.paginate.to = r.data.to
                this.statusList = true
            }).catch(e => { this.statusList = true; this.erro(e) })
        },

        trocarCaixa () { this.paginate.page = 1; this.carregar() },

        aoTrocarGrupo () { this.paginate.page = 1; this.carregar() },

        corSituacao (s) {
            if (s === 'enviada')   return 'primary'
            if (s === 'concluida') return 'success'
            if (s === 'cancelada') return 'danger'
            if (s === 'agendada')  return 'warning'
            return 'info'
        },

        textoPrazo (t) {
            if (t.prazo_vencido) return 'vencido'
            if (t.horas_restantes < 24) return t.horas_restantes + 'h'
            return Math.floor(t.horas_restantes / 24) + 'd'
        },

        alternar (id) {
            const i = this.selecionadas.indexOf(id)
            if (i >= 0) this.selecionadas.splice(i, 1)
            else this.selecionadas.push(id)
        },

        alternarTodas () {
            this.selecionadas = this.todasSelecionadas ? [] : this.items.map(t => t.id)
        },

        // CI 56 — marcar lida/não lida em lote
        marcarLote (lida) {
            if (!this.selecionadas.length) return

            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa/marcar-lida`,
                { ids: this.selecionadas, lida: lida }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        // CI 25 — arquivar e desarquivar
        arquivar (t, arquivar) {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.base()}/api/tarefa/arquivar/${t.id}`,
                { arquivar: arquivar }, this.auth()).then(() => {
                window.eventBus.$emit('loading', false)
                window.eventBus.$emit('alert', {
                    msg: arquivar ? 'Sucesso! - Tarefa arquivada.' : 'Sucesso! - Tarefa desarquivada.',
                    type: 'success'
                })
                this.carregar()
            }).catch(e => { this.erro(e) })
        },

        excluir (t) {
            this.$msgbox.confirm('Excluir este rascunho?', 'Atenção',
                { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' }
            ).then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.delete(`${this.base()}/api/tarefa/remover/${t.id}`, this.auth()).then(() => {
                    window.eventBus.$emit('loading', false)
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Rascunho excluído.', type: 'success' })
                    this.carregar()
                }).catch(e => { this.erro(e) })
            }).catch(() => {})
        },

        getPagePagination (page) { this.paginate.page = page; this.carregar() }
    },
    components: {  }
}
</script>
<style scoped>
.nao-lida    { font-weight: 600; background: #fbfdff !important; }
.ident       { font-family: monospace; font-size: 12px; color: #606266; }
.assunto     { color: #303133; text-decoration: none; }
.assunto:hover { color: #409EFF; }
.trecho      { font-size: 12px; color: #909399; font-weight: 400; margin-top: 3px; }
.prazo-vencido { color: #F56C6C; font-weight: 600; }
.prazo-ok      { color: #67C23A; }
.u-ml-5      { margin-left: 5px; }
</style>
